// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style__wrap___2Dm7K"};